import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface DropOffConfirmationModalProps {
	visible: boolean;
	type: 'someoneElse' | 'youForSomeoneElse';
	contactName: string;
	onConfirm: () => void;
	onCancel: () => void;
}

const DropOffConfirmationModal: FC<DropOffConfirmationModalProps> = ({
	visible,
	type,
	contactName,
	onConfirm,
	onCancel,
}): React.ReactElement => {
	const bodyText =
		type === 'someoneElse'
			? "This tool was picked up by someone else, and dropping off will remove it from their 'In use' tool list."
			: "This tool was picked up by you for someone else, and dropping off will remove it from their 'In use' tool list.";

	return (
		<Modal
			visible={visible}
			width={520}
			closable={false}
			title={null}
			footer={[
				<Button key="no" onClick={onCancel} size="large">
					No
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="yes"
					onClick={onConfirm}
				>
					Yes, Drop Off
				</Button>,
			]}
		>
			<div className="flex flex-col items-center text-center">
				<ExclamationCircleOutlined style={{ color: '#d4a843', fontSize: 24 }} />
				<div className="mt-4">
					<span className="h5medium">Drop off for {contactName}?</span>
				</div>
				<div className="bodyregular mt-2 text-character-secondary">{bodyText}</div>
			</div>
		</Modal>
	);
};

export default DropOffConfirmationModal;
